import clsx from "clsx";

interface Props {
  value: number;
}

export const GradientBar = ({ value }: Props) => {
  const blankPercent = 100 - Math.abs(value) * 100;

  return (
    <div
      className={clsx(
        "relative h-2.5 w-full bg-gradient-to-r from-cosmic+1 via-gray-2 to-alien+1",
        "border border-gray-1 rounded-full overflow-hidden",
      )}
    >
      <div
        className="absolute h-full bg-v2-primary"
        style={{
          left: value > 0 ? "0" : "50%",
          width: "50%",
        }}
      ></div>
      <div
        className="absolute h-full"
        style={
          value === 0
            ? {
                left: 0,
                width: "100%",
                backgroundColor: "white",
              }
            : value > 0
            ? {
                right: 0,
                width: `calc(${blankPercent}%/2)`,
                backgroundColor: "#e5efe6",
              }
            : {
                left: 0,
                width: `calc(${blankPercent}%/2)`,
                backgroundColor: "#f7f7ff",
              }
        }
      ></div>
      <div className="absolute h-full w-[1px] bg-interstellar-1 left-1/2"></div>
    </div>
  );
};
